import { kpiQueryOptions } from '@/dashboards/CompetitorsMediaInvestment/api';
import { useCompetitorsMediaInvestmentUrl } from '@/dashboards/CompetitorsMediaInvestment/hooks/useCompetitorsMediaInvestmentUrl';
import { useDuckDBQuery } from '@/duckdb';

export const useKpiData = () => {
    const { search } = useCompetitorsMediaInvestmentUrl();
    const { period, startDate, endDate } = search;

    const queryResult = useDuckDBQuery(
        kpiQueryOptions(period, startDate, endDate),
    );

    return { queryResult };
};
